module.exports = __webpack_public_path__ + "static/eq-6112cf11836fbc62e9b604b76a894e8a.png";